/**
 * The line under an impact card explaining what the figure leaves out.
 *
 * Shown rather than hidden: a total that silently excludes half the registered
 * materials looks like a complete measurement. Naming the count is what makes
 * it honest, and it doubles as the prompt to go fill in a conversion factor.
 *
 * @param {object} props
 * @param {number} props.unknownCount - Materials that produced no figure
 * @param {string|null} props.error - Set when the standaard itself failed to load
 */
const ImpactUnknownNote = ({ unknownCount, error }) => {
    if (error) {
        return (
            <p className='adress-impact-note adress-impact-note-error'>
                De meetstandaard kon niet worden opgehaald, dus er is niets berekend.
            </p>
        )
    }

    if (!unknownCount) return null

    return (
        <p className='adress-impact-note'>
            {unknownCount === 1
                ? '1 materiaal telt niet mee — er ontbreekt een koppeling of omrekenfactor.'
                : `${unknownCount} materialen tellen niet mee — er ontbreekt een koppeling of omrekenfactor.`}
        </p>
    )
}

export default ImpactUnknownNote
